//import vendor css
import 'angular-loading-bar/build/loading-bar.css';
import 'components-font-awesome/css/font-awesome.css';
import 'ng-sortable/dist/ng-sortable.css';
import 'ui-select/dist/select.css';
import 'angular-wizard/dist/angular-wizard.min.css';
import 'angular-ui-switch/angular-ui-switch.css';
import 'c3/c3.css';
import 'angular-bootstrap/ui-bootstrap-csp.css';
import 'angular/angular-csp.css';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'ng-tags-input/build/ng-tags-input.css';

// import css
import 'style/main.less';
import 'style/prisma.css';
import 'style/animate.css';
import 'style/fonts.css';
import 'style/prisma-custom.css';
import 'style/inline.css';
